<template>
    <templateLogin>
        <div class="header">
        </div>
        <div class="body">
            <section class="box-login">
                <form v-on:submit="doPasswordRecover" action="#" method="post">
                    <div class="title">
                        <h1>{{title}}</h1>
                        <p>{{text}}</p>
                    </div>
                    <div v-show="message" class="message mb-15" v-html="message"></div>
                    <ui-input label="E-mail:" size="md3" type="email" ref="username" v-model.trim="form.email"></ui-input>
                    <div class="control">
                        <ui-button  :class="status"
                            :loading="status === 'loading'"
                            type="submit"
                            design="lg primary block">
                            Avançar
                        </ui-button>
                    </div>
                    <div class="back-link">
                        <router-link to="/login"><i class="fal fa-long-arrow-left"></i> Voltar</router-link>
                    </div>
                </form>
            </section>
        </div>
    </templateLogin>
</template>
<script>
    import templateLogin from '@/templates/page-login'
    import { uiButton } from '@/components/ui/buttons'
    import { uiInput } from '@/components/ui/form'

    import { resetPassword } from '@/services/axios'

    export default {
        components: { templateLogin, uiButton, uiInput },

        data() {
            return {
                title: 'Informe o e-mail cadastrado',
                text: 'Informe o e-mail vinculado a sua conta.',
                message: '',
                status: '',
                form: {
                    email: '',
                },
            }
        },

        methods: {
            doPasswordRecover(event){
                event.preventDefault()
                this.status = 'loading'

                if (!this.form.email) {
                    this.$refs.username.$el.classList.add('error')
                    this.message    = 'É necessário informar o seu e-mail.'
                    this.status     = false
                    return false
                }

                resetPassword.checkEmail(this.form).then(response => {
                    if (response.data.status !== "error") {
                        this.$router.push({
                            name: 'passwordRecoverByEmailOrSMS',
                            params: {
								email: this.form.email,
                                type: !response.data.data.user_mobile ? 'email' : ''
                            }
                        })
                    }
                    this.message = response.data.msg
                    this.status = false
                })
            },
        }
    }
</script>
